import { useState } from "react";
import { TailwindSpinner } from "../../components/Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { useGetCustomerProfile } from "../../hooks/Query/useGetCustomerProfile";
import { LoadingIcon } from "../../assets/icons";


export default function HandleMemberQuery() {
    const navigate = useNavigate();
    const [membershipId, setMembershipId] = useState("");
    const [searchId, setSearchId] = useState("");

    const { data: profileData, isFetching: loading } = useGetCustomerProfile({
        membership_id: searchId,
    });

    const profile = profileData?.data?.profile;

    const handleSearch = () => {
        if (!membershipId) return;
        setSearchId(membershipId);
    };

    return (
        <div className="p-6 bg-white rounded-lg min-h-[90vh]">
            <div className="mb-[29px]">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Membership ID <span className="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    value={membershipId}
                    onChange={(e) => setMembershipId(e.target.value)}
                    placeholder="Select"
                    className="w-full md:w-[700px] px-3 py-2 border border-gray-300 rounded-[5px] h-[35px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-sm"
                />
            </div>

            <button
                onClick={handleSearch}
                disabled={loading || !membershipId}
                className="bg-mysecondary hover:bg-blue-800 text-white px-8 py-2 rounded flex items-center justify-center w-[180px] h-[38px] text-sm"
            >
                {loading ? <TailwindSpinner /> : "Search"}
            </button>

            {searchId && (
                <div className="mt-[70px] overflow-hidden">
                    <div className="overflow-y-auto max-h-[470px]">
                        <table className="w-full text-sm text-left">
                            <thead className="bg-[#F8FAFC] sticky top-0 h-[44px]">
                                <tr>
                                    <th className="px-4 py-3 text-[#000000] text-[12px] border-b whitespace-nowrap">Membership ID ↓</th>
                                    <th className="px-4 py-3 text-[#000000] text-[12px] border-b whitespace-nowrap">First Name ↓</th>
                                    <th className="px-4 py-3 text-[#000000] text-[12px] border-b whitespace-nowrap">Last Name ↓</th>
                                    <th className="px-4 py-3 text-[#000000] text-[12px] border-b whitespace-nowrap">Phone Number ↓</th>
                                    <th className="px-4 py-3 text-[#000000] text-[12px] border-b whitespace-nowrap">Email Address ↓</th>
                                    <th className="px-4 py-3 text-[#000000] text-[12px] border-b whitespace-nowrap">Action ↓</th>
                                    <th className="px-4 py-3 text-[#000000] text-[12px] border-b whitespace-nowrap"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={6} className="text-center py-10">
                                            <div className="flex justify-center"><LoadingIcon /></div>
                                        </td>
                                    </tr>
                                ) : profile ? (
                                    <tr
                                        className="border-b h-[70px] transition-colors"
                                        // onClick={() => navigate(`/handle-member-query/${profile.Membership_id}`)}
                                    >
                                        <td className="px-4 py-3 text-[#64748B] text-[14px]">{profile.Membership_id}</td>
                                        <td className="px-4 py-3 text-[#64748B] text-[14px]">{profile.username}</td>
                                        <td className="px-4 py-3 text-[#64748B] text-[14px]">-</td>
                                        <td className="px-4 py-3 text-[#64748B] text-[14px]">-</td>
                                        <td className="px-4 py-3 text-[#64748B] text-[14px]">-</td>
                                        <td className="px-4 py-3 text-[#64748B] text-[14px]">{profile.Membership_status}</td>
                                        <td className="px-4 py-3 text-[#64748B] text-[14px]">
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/handle-member-query/${profile.Membership_id}`);
                                                }}
                                                className="text-blue-800 px-4 py-2 rounded-[5px] text-[14px] hover:underline"
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ) : (
                                    <tr>
                                        <td colSpan={6} className="text-center text-gray-400 py-10">
                                            No member found for "{searchId}"
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {!searchId && (
                <div className="mt-[70px] bg-[#F5F5F5] h-[300px] flex items-center justify-center">
                    <p className="text-[#6D6D6D] text-[14px]">
                        Search for a membership ID to see results
                    </p>
                </div>
            )}

        </div>
    );
}